export default "__VITE_ASSET__wYVLqTIZ__"